import { Button, Input } from 'react-daisyui';
import { useTranslation } from 'react-i18next';
import { useTeamContext } from '../../../Team.context';
import { isUndefined } from 'lodash';
import Select from 'react-select';
import { ROLE_OPTIONS } from '../../../Team.constants';
import { eUserRole } from '../../../../../../../providers/UserProvider/User.enums';
import { useState } from 'react';
import { useWorkspaceContext } from 'src/providers/WorkspaceProvider/Workspace.context';

export default function ManageWorkspaceUserForm() {
  const { t } = useTranslation('settings/team');
  const [isPipesDirty, setIsPipesDirty] = useState<boolean>(false);
  const {
    editUserFormik,
    updatingUser,
    setShowConfirmEditUserModal,
    pipesSelectionOptions,
  } = useTeamContext();
  const { workspaceInfo } = useWorkspaceContext();

  if (isUndefined(editUserFormik)) {
    return <></>;
  }
  return (
    <div className="TeamSection__Modal__Form">
      <div className="TeamSection__Modal__FieldContainer">
        <div className="TeamSection__Modal__FieldContainerInputs">
          <label className="label">
            <span className="label-text">{t('page.form.label.rol.text')}</span>
          </label>
          <Select
            options={ROLE_OPTIONS}
            id="role"
            name="role"
            value={editUserFormik.values.role}
            onChange={(value) => editUserFormik.setFieldValue('role', value)}
            onBlur={editUserFormik.handleBlur}
            isDisabled={editUserFormik.values.role.value === eUserRole.OWNER}
          />
        </div>
        <div className="TeamSection__Modal__FieldContainerInputs">
          <label className="label">
            <span className="label-text">{t('page.form.label.goal.text')}</span>
          </label>
          <Input
            id="goal"
            name="goal"
            value={editUserFormik.values.goal?.toString() ?? ''}
            onChange={(e) => {
              const numericValue = e.target.value === '' ? 0 : Number(e.target.value);
              editUserFormik.setFieldValue('goal', numericValue);
            }}
            onBlur={editUserFormik.handleBlur}
            className="w-full"
            placeholder={t('page.form.placeholder.goal')}
            type="number"
          />
        </div>
      </div>
      {!workspaceInfo?.userManagementV2 && (
        <div className="TeamSection__Modal__Form__Container mt-5">
          <div className="TeamSection__Modal__Form__New__User">
            <label className="label">{t('page.form.label.pipes.text')}</label>
            <Select
              options={pipesSelectionOptions}
              id="pipes"
              name="pipes"
              value={editUserFormik.values.pipes}
              onChange={(value) => {
                editUserFormik.setFieldValue('pipes', value);
                setIsPipesDirty(true);
              }}
              onBlur={editUserFormik.handleBlur}
              isDisabled={
                editUserFormik.values.role.label === eUserRole.ADMIN ||
                editUserFormik.values.role.label === eUserRole.OWNER
              }
              isMulti
            />
            {editUserFormik.values.role.label === eUserRole.ADMIN ||
            editUserFormik.values.role.label === eUserRole.OWNER ? (
              <span className="text-sm text-primary">
                {t('page.totalAccessAdminOrOwner')}
              </span>
            ) : null}
            {editUserFormik.touched.pipes &&
            editUserFormik.values.pipes.length <= 0 ? (
              <div className="ProfileForm__errorMessage">
                El usuario debe tener acceso a al menos un embudo
              </div>
            ) : null}
          </div>
          {editUserFormik.values.role.label === eUserRole.SELLER ? (
            <div>
              <p className="text-sm my-2">
                <span className="text-sm font-bold">
                  ⚠️ {t('page.legend.title')}{' '}
                </span>
                <span className="text-sm text-gray-500">
                  {t('page.legend.text')}{' '}
                </span>
                <span className="text-sm font-bold">
                  {t('page.legend.text2')}
                </span>
              </p>
            </div>
          ) : null}
        </div>
      )}
      <div className="TeamSection__Modal__Form__ButtonContainer">
        <Button
          type="submit"
          className="ProfileForm__submitButton"
          size="md"
          color="primary"
          loading={updatingUser}
          onClick={async (e) => {
            e.preventDefault();
            if (isPipesDirty) {
              setShowConfirmEditUserModal(true);
            } else {
              setIsPipesDirty(false);
              // Validate and submit the form
              const errors = await editUserFormik.validateForm();
              if (Object.keys(errors).length === 0) {
                editUserFormik.handleSubmit();
              } else {
                // Set touched to show validation errors
                editUserFormik.setTouched({
                  role: { value: true, label: true },
                  goal: true,
                  pipes: editUserFormik.values.pipes.map(() => ({ value: true, label: true })),
                });
              }
            }
          }}
        >
          {t('page.form.button.update-member.text')}
        </Button>
      </div>
    </div>
  );
}
